import React from "react";

export const LoadingSpinner = ({ size = 16 }) => {
  return (
    <div className="loading-container">
      <span
        className="loading-spinner"
        style={{ width: size, height: size }}
        aria-label="loading"
          />
          <p>A carregar...</p>
    </div>
  );
};
